module.exports = __webpack_public_path__ + "img/pic_jianli.021e165f.png";